export const dataHooks = {
  leanAppPageInfo: 'lean-app-page-info',
  leanAppPageInfoAppInfo: 'lean-app-page-info-app-info',
  leanAppPageInfoLeanHeaderContainer:
    'lean-app-page-info-lean-header-container',
  leanAppPageInfoAppGallery: 'lean-app-page-info-app-gallery',
};
